// Cliente das rotas de layout de impressão do alfredo-central-backend.
import api from "./api.service";
import { DocumentoComanda, LayoutComanda } from "../comum/layout-comanda";

class LayoutComandaClass {
  /**
   * Layout gravado; se ainda não houver, o backend devolve o padrão do sistema.
   *
   * `ambientUuid` importa: o layout é gravado POR AMBIENTE (`ActLayout` tem FK
   * para `ActAmbient`). Sem ele o backend responde pelo que achar primeiro, que
   * é justamente o que a tela fazia antes — e o dono editava o layout de um
   * ambiente achando que era de outro.
   */
  async buscar(
    documento: DocumentoComanda,
    ambientUuid?: string
  ): Promise<{
    documento: DocumentoComanda;
    layout: LayoutComanda;
    gravado: boolean;
  }> {
    const parametros = new URLSearchParams();
    if (ambientUuid) parametros.set("ambientUuid", ambientUuid);
    const consulta = parametros.toString();
    const resposta = await api.get(
      `/layoutComanda/${documento}${consulta ? `?${consulta}` : ""}`
    );
    return resposta.data;
  }

  /**
   * `updatedBy` é OBRIGATÓRIO e é novo: o backend nunca populava
   * `request.userUuid` e acabava gravando undefined numa coluna NOT NULL com
   * FK. Ele agora lê o autor do corpo — quem chama tem que mandar o userUuid do
   * token, e recusar o salvamento antes da requisição se não tiver.
   */
  async salvar(
    documento: DocumentoComanda,
    layout: LayoutComanda,
    ambientUuid: string,
    updatedBy: string
  ) {
    const resposta = await api.put(`/layoutComanda/${documento}`, {
      layout,
      ambientUuid,
      updatedBy,
    });
    return resposta.data;
  }

  /**
   * Preview renderizado no servidor. O front já sabe renderizar sozinho (é o
   * mesmo módulo); este endpoint existe para conferir de fora que backend,
   * front e OPS produzem as mesmas linhas.
   */
  async preview(
    documento: DocumentoComanda,
    opcoes: { exemplo?: "mesa" | "delivery"; papel?: 80 | 58 } = {}
  ) {
    const parametros = new URLSearchParams();
    if (opcoes.exemplo) parametros.set("exemplo", opcoes.exemplo);
    if (opcoes.papel) parametros.set("papel", String(opcoes.papel));
    const resposta = await api.get(
      `/layoutComanda/${documento}/preview?${parametros.toString()}`
    );
    return resposta.data;
  }
}

export const layoutComandaService = new LayoutComandaClass();
